// Entry files are intended for importing and executing functions and classes only. They should not contain any logic.
import collection from '../objects/collection'

collection()
